export default __webpack_public_path__ + "static/media/chatList-next-allow.5f516e29.svg";